<template>
  <div class="container" v-loading="loading">
    <page-header
      title="Manifest"
      breadcrumb="Dashboard > Bookings & Shipments > Dispatch Management > Manifest"
      :back="{ name: 'Dispatch' }"
    />
    <div v-if="Object.keys(manifest).length > 0">
      <div class="card p-0" id="printable">
        <div class="actions" v-if="showAction">
          <div>
            <p>Actions</p>
            <hr />
          </div>
        </div>

        <div class="w-100 grid grid-cols-12 mt-3 py-2">
          <div
            class="col-span-4 px-4 flex flex-wrap justify-evenly border-r-2 border-gray-200"
          >
            <p class="mt-1">
              <img class="" src="../../../../assets/images/icons/number-hash-icon.png" />
            </p>
            <p class="w-10/12 font-semibold text-lg">
              Shipping Ref: #{{ manifest.dispatch.dispatchReference }}
            </p>
          </div>

          <div
            class="col-span-3 flex flex-wrap justify-evenly border-r-2 border-gray-200"
          >
            <p class="mt-1 -mr-8">
              <img src="../../../../assets/images/icons/list-icon.png" />
            </p>
            <p class="font-semibold text-lg">
              Item No : {{ manifest.dispatch.consolidation.shippings.length }}
            </p>
          </div>

          <div class="col-span-4 px-3 flex flex-wrap justify-evenly">
            <p class="mt-1">
              <img src="../../../../assets/images/icons/weight-icon.png" />
            </p>
            <p class="font-semibold text-lg">Total weight: {{ getTotalWeight }} Tonnes</p>
          </div>
          <div class="cursor-pointer mt-2 mr-3 text-right">
            <el-dropdown
              trigger="click"
              :hide-on-click="true"
              placement="top"
              @command="performAction"
            >
              <button class="p-2 -mt-2 list-button text-[#6E6893] rounded-md">
                <img src="../../../../assets/images/icons/more-action-icon.png" />
              </button>

              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="print">
                  <button class="flex flex-nowrap w-full p-1 text-left">
                    <div class="pt-2 mr-3">
                      <img src="../../../../assets/images/icons/print.png" class="" />
                    </div>

                    <p class="">Print</p>
                  </button>
                </el-dropdown-item>
                <el-dropdown-item command="share">
                  <button class="flex flex-nowrap w-full p-1 text-left">
                    <div class="pt-2 mr-3">
                      <img src="../../../../assets/images/icons/share.png" class="" />
                    </div>

                    <p class="">Share</p>
                  </button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div
                    @click="
                      $router.push({
                        name: 'DispatchTimeline',
                        params: { dispatchID: manifest.dispatch.id },
                      })
                    "
                  >
                    <button class="flex flex-nowrap w-full p-1 text-left">
                      <div class="pt-2 mr-3">
                        <img
                          src="../../../../assets/images/icons/view-details-timeline.png"
                          class=""
                        />
                      </div>

                      <p class="">View Timeline</p>
                    </button>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div
          class="col-span-1 p-4 mt-4 flex gap-4 text-white"
          style="background: #09b78a"
        >
          <div class="rounded-full text-center w-16 h-16 bg-white">
            <img
              class="mx-auto block mt-3"
              src="../../../../assets/images/icons/fluent-tag-icon.png"
            />
          </div>
          <div class="flex flex-col">
            <p class="font-semibold text-xl">Standard Shipping</p>
            <span>This order has been shipped to the customer</span>
          </div>
        </div>

        <div
          class="flex justify-between mt-4 px-4 p-3"
          @click="collapsed = !collapsed"
          style="background: #f9fafc"
        >
          <p class="font-semibold">Dispatch/Shipping Information</p>
          <p class="flex gap-2 items-center cursor-pointer" v-if="collapsed">
            <span>
              <svg
                width="14"
                height="9"
                viewBox="0 0 14 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.6466 8.5L13.7644 7.38219L6.88219 0.5L0 7.38219L1.11781 8.5L6.88219 2.73562L12.6466 8.5Z"
                  fill="#10233E"
                />
              </svg>
            </span>
            Collapse
          </p>
          <p class="flex gap-2 items-center cursor-pointer" v-else>
            <span>
              <svg
                width="14"
                height="9"
                viewBox="0 0 14 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.6466 0.5L13.7644 1.61781L6.88219 8.5L0 1.61781L1.11781 0.5L6.88219 6.26438L12.6466 0.5Z"
                  fill="#321C3B"
                />
              </svg>
            </span>
            Expand
          </p>
        </div>
        <div v-if="collapsed" style="background-color: #f9fafc" class="p-4">
          <div class="row p-2 pl-3 mb-3 rounded-lg borrder border-gray-400">
            <div class="col-md-6">
              <h3 class="text-green text-xl mb-3">Vehicle Info</h3>
              <div class="flex flex-wrap">
                <p class="w-1/2 text-gray-500 flex flex-wrap justify-between">
                  <span class="w-1/2">Vehicle No.</span> <span class="w-1/2">:</span>
                </p>
                <p class="w-1/2 font-semibold text-left">
                  {{ manifest.dispatch.consolidation.fleet.vinnumber }}
                </p>
              </div>

              <div class="flex flex-wrap">
                <p class="w-1/2 text-gray-500 flex flex-wrap justify-between">
                  <span class="w-1/2">Driver</span> <span class="w-1/2">:</span>
                </p>
                <p class="w-1/2 font-semibold text-left">
                  {{
                    manifest.dispatch.consolidation.fleet.driverName
                      ? ""
                      : manifest.dispatch.consolidation.fleet.driverName
                  }}
                </p>
              </div>

              <div class="flex flex-wrap">
                <p class="w-1/2 text-gray-500 flex flex-wrap justify-between">
                  <span class="w-1/2">Contact No.</span> <span class="w-1/2">:</span>
                </p>
                <p class="w-1/2 font-semibold text-left">
                  {{
                    manifest.dispatch.consolidation.fleet.driverMobile
                      ? ""
                      : manifest.dispatch.consolidation.fleet.driverMobile
                  }}
                </p>
              </div>

              <div class="flex flex-wrap">
                <p class="w-1/2 text-gray-500 flex flex-wrap justify-between">
                  <span class="w-1/2">Max. Capacity</span> <span class="w-1/2">:</span>
                </p>
                <p class="w-1/2 font-semibold text-left">
                  {{ manifest.dispatch.consolidation.fleet.carriageCapacity }} Tonnes
                </p>
              </div>

                <div class="flex flex-wrap">
                  <p class="w-1/2 text-gray-500 flex flex-wrap justify-between"><span class="w-1/2">Load Capacity</span> <span class="w-1/2">:</span></p>  
                  <p class="w-1/2 font-semibold text-left">{{ manifest.dispatch.consolidation.fleet.currentLoadCapacity }} Tonnes</p>
                </div>
              </div>
              <div class="col-md-6">
                <h3 class="text-green text-xl mb-3">Company Contact</h3>
                
                <div class="flex flex-wrap justify-start">
                  <p class="w-1/2 text-gray-500 flex flex-wrap justify-between"><span class="w-1/2">Contact Name</span> <span class="w-1/2">:</span></p>  
                  <p class="w-1/2 font-semibold text-left">{{ manifest.orgDetails.companyname }}</p>
                </div>
                <div class="flex flex-wrap">
                  <p class="w-1/2 text-gray-500 flex flex-wrap justify-between"><span class="w-1/2">Office Address</span> <span class="w-1/2">:</span></p>  
                  <p class="w-1/2 font-semibold text-left">{{ manifest.orgDetails.address ? manifest.orgDetails.address.name : "N.A" }}</p>
                </div>
                <div class="flex flex-wrap">
                  <p class="w-1/2 text-gray-500 flex flex-wrap justify-between"><span class="w-1/2">Contact No.</span> <span class="w-1/2">:</span></p>  
                  <p class="w-1/2 font-semibold text-left">{{ manifest.orgDetails.mobile_no }}</p>
                </div>
                <div class="flex flex-wrap">
                  <p class="w-1/2 text-gray-500 flex flex-wrap justify-between"><span class="w-1/2">Whatsapp</span> <span class="w-1/2">:</span></p>  
                  <p class="w-1/2 font-semibold text-left">{{ manifest.orgDetails.mobile_no }}</p>
                </div>
                <div class="flex flex-wrap">
                  <p class="w-1/2 text-gray-500 flex flex-wrap justify-between"><span class="w-1/2">Contact Email</span> <span class="w-1/2">:</span></p>  
                  <p class="w-1/2 font-semibold text-left">{{ manifest.orgDetails.email }}</p>
                </div>
              </div>
            </div>
            <div class="row p-2 pl-3">
              <div class="col-md-6">
                <h3 class="text-green text-xl mb-3">From</h3>
                <div class="flex flex-wrap">
                  <p class="w-1/2 text-gray-500 flex flex-wrap justify-between"><span class="w-1/2">Company Name</span> <span class="w-1/2">:</span></p>  
                  <p class="w-1/2 font-semibold text-left">{{ manifest.orgDetails.companyname }}</p>
                </div>
                <div class="flex flex-wrap">
                  <p class="w-1/2 text-gray-500 flex flex-wrap justify-between"><span class="w-1/2">Email</span> <span class="w-1/2">:</span></p>  
                  <p class="w-1/2 font-semibold text-left">{{ manifest.orgDetails.email }}</p>
                </div>
                <div class="flex flex-wrap">
                  <p class="w-1/2 text-gray-500 flex flex-wrap justify-between"><span class="w-1/2">Dispatcher</span> <span class="w-1/2">:</span></p>  
                  <p class="w-1/2 font-semibold text-left">{{ $store.getters.user.firstname + ' ' + $store.getters.user.lastname}}</p> 
                </div>
                <div class="flex flex-wrap">
                  <p class="w-1/2 text-gray-500 flex flex-wrap justify-between"><span class="w-1/2">Contact No</span> <span class="w-1/2">:</span></p>  
                  <p class="w-1/2 font-semibold text-left">{{ $store.getters.user.mobile_no }}</p>
                </div>
                <div class="flex flex-wrap">
                  <p class="w-1/2 text-gray-500 flex flex-wrap justify-between"><span class="w-1/2">Contact Email</span> <span class="w-1/2">:</span></p>  
                  <p class="w-1/2 font-semibold text-left">{{ $store.getters.user.email }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <h3 class="text-green text-xl mb-3">To</h3>

              <div class="flex flex-wrap">
                <p class="w-1/2 text-gray-500 flex flex-wrap justify-between">
                  <span class="w-1/2">Company Name</span> <span class="w-1/2">:</span>
                </p>
                <p class="w-1/2 font-semibold text-left">
                  {{ manifest.orgDetails.companyname }}
                </p>
              </div>
              <div class="flex flex-wrap">
                <p class="w-1/2 text-gray-500 flex flex-wrap justify-between">
                  <span class="w-1/2">Email</span> <span class="w-1/2">:</span>
                </p>
                <p class="w-1/2 font-semibold text-left">
                  {{ manifest.orgDetails.email }}
                </p>
              </div>
              <div class="flex flex-wrap">
                <p class="w-1/2 text-gray-500 flex flex-wrap justify-between">
                  <span class="w-1/2">Receiver Name</span> <span class="w-1/2">:</span>
                </p>
                <p class="w-1/2 font-semibold text-left">N.A</p>
              </div>
              <div class="flex flex-wrap">
                <p class="w-1/2 text-gray-500 flex flex-wrap justify-between">
                  <span class="w-1/2">Contact No</span> <span class="w-1/2">:</span>
                </p>
                <p class="w-1/2 font-semibold text-left">N.A</p>
              </div>
              <div class="flex flex-wrap">
                <p class="w-1/2 text-gray-500 flex flex-wrap justify-between">
                  <span class="w-1/2">Contact Email</span> <span class="w-1/2">:</span>
                </p>
                <p class="w-1/2 font-semibold text-left">N.A</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="mt-5 table-header flex flex-nowrap bg-[#E5E5E5] text-md justify-around p-4 pl-11 border-y-1 border-[#D9D5EC] overflow-wrap text-[#383F51]"
      >
        <p class="w-3/12 text-[#383F51]">SHIPPING REF.</p>
        <p class="w-3/12 ml-2">PART OF (CONS ID #)</p>
        <p class="w-3/12 ml-2">COUNTER</p>
        <p class="w-5/12 ml-2">DESCRIPTION</p>
        <p class="w-3/12 ml-2">LOAD WEIGHT</p>
        <p class="w-3/12 ml-2">SHIPPING SERVICE</p>
        <p class="w-4/12 ml-2">SHIPPING INSTRUCTION</p>
        <p class="w-4/12 ml-2">EST. DELIVERY DATE</p>
      </div>
      <TablerowBase2
        class="mt-3"
        v-for="(shipping, index) in manifest.dispatch.consolidation.shippings"
        :key="shipping.id"
        :count="index + 1"
        :total="manifest.dispatch.consolidation.shippings.length"
        :consolidationReference="manifest.dispatch.consolidation.consolidationReference"
        @refetch-shipping="$emit('refetch-shipping')"
        :shipping="shipping"
      />

      <UpdateStatusModal
        :showmodal="showupdateModal"
        :currentStatus="manifest.dispatch.dispatchStatus"
        :lastUpdated="manifest.dispatch.updatedAt"
        :dispatchId="manifest.dispatch.id"
        @refetch-dispatch="getDispatchTimeline"
        @close-modal="showupdateModal = false"
        :statuses="['in-bound', 'accidented', 'delayed', 'received', 'delivered']"
      />
      <pagination-control />
      <share-link
        :show-modal="shareLinkModal"
        :refNo="manifest.dispatch.dispatchReference"
        @close-modal="shareLinkModal = false"
      />
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import PaginationControl from "@/components/UI/NewPagination";
import TablerowBase2 from "@/components/3pl/Operations/Dispatch/TablerowBase2";
import UpdateStatusModal from "@/components/3pl/Operations/Dispatch/Modals/UpdateStatusModal";
import ShareLink from "./modals/shareLink.vue";

export default {
  components: {
    PageHeader,
    PaginationControl,
    TablerowBase2,
    UpdateStatusModal,
    ShareLink,
  },
  props: ["back"],
  data() {
    return {
      collapsed: true,
      showAction: false,
      shareLinkModal: false,
      loading: false,
      fleet: {},
      manifest: {},
      showupdateModal: false,
      toLocation: {},
    };
  },
  computed: {
    getTotalWeight() {
      let weight = 0;
      this.manifest.dispatch.consolidation.shippings.forEach((x) => {
        x.packagees.forEach((y) => {
          weight += y.estimatedWeight * y.quantity;
        });
      });

      let convertRate = 907.185;
      let fullWeight = weight / convertRate;

      return fullWeight.toString().slice(0, 5);
    },
  },
  mounted() {
    this.getDispatchManifest();
  },
  methods: {
    printElement() {
      var $printSection = document.getElementById("printable");

      if (!$printSection) {
        $printSection = document.createElement("div");
        $printSection.id = "printSection";
        document.body.appendChild($printSection);
      }

      window.print();
    },
    performAction(action) {
      if (action == "print") {
        this.printElement();
      } else if (action == "share") {
        this.shareLinkModal = true;
      } else if (action == "statusmodal") {
        this.showupdateModal = true;
      }
    },
    toggleAction() {
      this.showAction = !this.showAction;
    },
    async getDispatchManifest(){
        const response = await this.$_getDispatch(this.$route.params.dispatchID)
        this.manifest = response.data.data

        const response2 = await this.$_getSingleLocationDetails(response.data.data.dispatch.consolidation.origin)
        console.log(response2)
        console.log(this.manifest)
    },
    async viewManifest() {
      this.loading = true;
      try {
        const response = await this.$_viewManifest(this.fleet.id);
        if (response.data.success) {
          this.loading = false;
          this.fleet = response.data.data.fleetDetails;
        }
      } catch (error) {
        this.loading = false;
        this.handleError(error);
      }
    },
    formatAddress(address) {
      if (typeof address === "object" && address !== null) {
        return address.name;
      }
      return address;
    },
    returnItemsWeights(packageItems) {
      const packageWeights = [];
      packageItems.forEach((item) => {
        if (item.weight) {
          packageWeights.push(item.weight);
        }
      });
      const weight = packageWeights.join(", ");
      return weight ? weight : "N.A";
    },
    returnPackageDescription(packageItems) {
      const packageDescriptions = [];
      packageItems.forEach((item) => {
        packageDescriptions.push(item.description);
      });
      return packageDescriptions.join(", ");
    },
  },
};
</script>

<style lang="scss" scoped>
.actions {
  position: absolute;
  background: #ffffff;
  top: 3rem;
  right: 2rem;
  padding: 0.75rem;
  z-index: 999;
  font-size: 0.9rem;
  width: 10rem;

  background: #ffffff;
  /* Stroke */

  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 10px;

  span {
    padding-right: 0.25rem;
  }
  > div {
    display: flex;
    align-items: center;
    padding-bottom: 0.5rem;
  }
}
.table-header {
  border-bottom: 1px solid #e1e3ea;
  p {
    color: #383f51;
    opacity: 0.5;
  }
}
</style>
